import { defineComponent as t, createBlock as r, openBlock as o, unref as c, mergeProps as m, withCtx as u, createElementVNode as e } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconReassuranceTruckOutlined",
  __name: "IconReassuranceTruckOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const n = l;
    return (s, a) => (o(), r(c(p), m(n, { "view-box": "0 0 48 48" }), {
      default: u(() => a[0] || (a[0] = [
        e("path", {
          "fill-rule": "evenodd",
          d: "M12.195 9.6a1.5 1.5 0 0 0-1.694 1.276l-.244 1.738a.5.5 0 1 1-.99-.14l.244-1.737a2.5 2.5 0 0 1 2.824-2.128l18.533 2.605a2.5 2.5 0 0 1 1.703 1.046l9.307 13.351a2.5 2.5 0 0 1 .425 1.778l-.788 5.607a2.5 2.5 0 0 1-2.824 2.127l-1.271-.178a4.255 4.255 0 0 1-8.369-1.176l-9.291-1.306a4.255 4.255 0 0 1-8.369-1.176l-2.2-.31a2.5 2.5 0 0 1-2.128-2.823L7.7 23.628a.5.5 0 1 1 .99.14l-.636 4.525a1.5 1.5 0 0 0 1.277 1.694l2.2.31a4.255 4.255 0 0 1 8.37 1.175l9.29 1.306a4.255 4.255 0 0 1 8.37 1.177l1.27.178a1.5 1.5 0 0 0 1.694-1.277l.788-5.607a1.5 1.5 0 0 0-.255-1.066l-9.306-13.351a1.5 1.5 0 0 0-1.022-.628L12.195 9.6m3.903 18.557a3.254 3.254 0 1 0-.906 6.445 3.254 3.254 0 0 0 .906-6.445m17.66 2.482a3.254 3.254 0 1 0-.905 6.445 3.254 3.254 0 0 0 .905-6.445",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M7.45 15.505a.5.5 0 0 0-.14.99l3.719.523a.5.5 0 0 0 .139-.99L7.45 15.505m-.522 3.718a.5.5 0 0 0-.14.99l7.436 1.046a.5.5 0 0 0 .14-.99l-7.436-1.046m20.721 1.435c.433.06.902-.632 1.021-1.538.13-.907-.136-1.675-.57-1.746-.433-.07-.893.621-1.022 1.528-.128.907.138 1.696.57 1.756m3.37-1.204c0 .91.366 1.675.805 1.655.481-.002.808-.737.806-1.658-.002-.921-.356-1.676-.806-1.665-.45.01-.807.757-.805 1.668m-7.785.997a.34.34 0 0 0-.246.058l.03-.001a.35.35 0 0 0-.114.355 7.103 7.103 0 0 0 1.5 2.385 7.794 7.794 0 0 0 1.044.953 8.372 8.372 0 0 0 3.875 1.556 8.529 8.529 0 0 0 2.757-.125.33.33 0 1 0-.08-.657 9.55 9.55 0 0 1-4.882-1.04 9.444 9.444 0 0 1-1.997-1.43 13.821 13.821 0 0 1-1.67-1.927.34.34 0 0 0-.217-.127" }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  f as default
};
